import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Search } from 'lucide-react';
import { SectionTabs } from './SectionTabs';
import { MobileNav } from './MobileNav';
import { SearchModal } from './SearchModal';
import { QuickAddDropdown } from './QuickAddDropdown';
import { UserMenu } from './UserMenu';
import { AlertDropdown, useActionItems } from '@/features/actionItems';

export function Header() {
  const { data: actionItems, isLoading: isLoadingActionItems, error: actionItemsError } = useActionItems();
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      <header className="flex h-12 items-center border-b border-border bg-background-subtle px-4">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 mr-6">
          <Box className="h-5 w-5 text-primary" />
          <span className="text-base font-semibold text-foreground whitespace-nowrap">Maker Toolchest</span>
        </Link>

        {/* Desktop section tabs - hidden on small screens */}
        <div className="hidden lg:block">
          <SectionTabs />
        </div>

        {/* Mobile nav dropdown - shown on small screens */}
        <div className="block lg:hidden">
          <MobileNav />
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Desktop search field - shown on larger screens */}
        <div className="hidden lg:flex w-64 mr-4">
          <div className="relative w-full">
            <Search className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-foreground-subtle" />
            <input
              type="text"
              placeholder="Search..."
              className="
                w-full rounded border border-border bg-background py-1 pl-8 pr-8
                text-sm text-foreground placeholder:text-foreground-subtle
                focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary
                transition-colors
              "
            />
            <kbd className="
              absolute right-2 top-1/2 -translate-y-1/2
              hidden xl:inline-flex h-4 items-center rounded border border-border
              bg-background-elevated px-1 text-[10px] text-foreground-subtle
            ">
              ⌘K
            </kbd>
          </div>
        </div>

        {/* Mobile search icon - shown on smaller screens */}
        <button
          onClick={() => setIsSearchOpen(true)}
          className="
            flex lg:hidden h-8 w-8 items-center justify-center rounded-md mr-2
            text-foreground-muted hover:bg-background-hover hover:text-foreground
            transition-colors
          "
          title="Search"
        >
          <Search className="h-5 w-5" />
        </button>

        {/* Alert dropdown */}
        <div className="mr-2">
          <AlertDropdown
            actionItems={actionItems ?? []}
            isLoading={isLoadingActionItems}
            error={actionItemsError}
          />
        </div>

        {/* Quick add dropdown */}
        <div className="mr-2">
          <QuickAddDropdown />
        </div>

        {/* User menu */}
        <UserMenu />
      </header>

      {/* Search modal */}
      <SearchModal isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
}
